import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = ({ isEmbedded = false }) => {
    return (
        <div className={isEmbedded ? "tnc-content-embedded" : "tnc-container"}>
            {!isEmbedded && (
                <div className="tnc-header">
                    <h2><i className="ri-file-shield-2-line"></i> Terms & Conditions</h2>
                    <p>Please read carefully before proceeding with any orders.</p>
                </div>
            )}

            <div className={isEmbedded ? "tnc-content-embedded-inner" : "tnc-content"}>
                <section className="tnc-section">
                    <h3><i className="ri-shield-check-line"></i> Safety Rules</h3>
                    <ul className="tnc-list">
                        <li>Never buy multiple products from the same listing.</li>
                        <li>Never buy the same product again from the same account (even a different variant).</li>
                        <li>SuperCoins / Coupons are <strong>NON-REFUNDABLE</strong> on all platforms.</li>
                        <li>Only standard delivery charges are refundable. <strong>Any extra fees are non-refundable.</strong></li>
                    </ul>
                </section>

                <section className="tnc-section">
                    <h3><i className="ri-lock-2-line"></i> Security & Tracking</h3>
                    <ul className="tnc-list">
                        <li>Drop Order ID, Review Name, Deal Type & Refund Amount in chat immediately after ordering. (Order screenshot not required)</li>
                        <li>If a deal is rejected, rejection details will be sent via WhatsApp — update immediately.</li>
                        <li><strong>Security Check:</strong> A verification video may be demanded to ensure no returns or fraud activity.</li>
                    </ul>
                    {!isEmbedded && (
                        <button className="btn-copy-format" onClick={() => {
                            const formatText = `Order ID: \nReview Name: \nDeal Type: \nRefund Amount: `;
                            navigator.clipboard.writeText(formatText);
                            alert('Format copied to clipboard!');
                        }}>
                            <i className="ri-file-copy-line"></i> Copy Format
                        </button>
                    )}
                </section>

                <section className="tnc-section highlight-blue">
                    <h3><i className="ri-checkbox-circle-line"></i> Mandatory Confirmation</h3>
                    <ul className="tnc-list" style={{ listStyle: 'none', padding: 0 }}>
                        <li style={{ marginBottom: '10px' }}><i className="ri-check-double-line" style={{ color: '#1e40af' }}></i> <strong>ALWAYS</strong> take written confirmation in chat before ordering.</li>
                        <li style={{ marginBottom: '10px' }}><i className="ri-check-double-line" style={{ color: '#1e40af' }}></i> Mandatory confirmation required for ordering or changing variants.</li>
                        <li style={{ marginBottom: '10px' }}><i className="ri-check-double-line" style={{ color: '#1e40af' }}></i> Order Form & Affiliate Form submission is compulsory.</li>
                        <li><i className="ri-error-warning-line" style={{ color: '#b91c1c' }}></i> Any confirmation outside official chat (calls, DMs, voice notes) will not be considered valid.</li>
                    </ul>
                </section>

                <div className="fraud-warning">
                    <h3><i className="ri-alarm-warning-fill"></i> ANTI-FRAUD POLICY</h3>
                    <p style={{ marginBottom: '1rem' }}>Any scam, manipulation, or policy abuse will result in immediate <strong>PERMANENT BAN</strong>.</p>
                    <p><strong>Return Fraud Warning:</strong> Returning products after filing for a refund will lead to <strong>PERMANENT BLOCK</strong> and reporting across all partner agencies.</p>
                </div>

                <section className="tnc-section" style={{ marginTop: '3rem' }}>
                    <h3><i className="ri-book-open-line"></i> Policy & Guidelines</h3>
                    <p>Follow all rules strictly to avoid refund rejection.</p>

                    <div className="guideline-block">
                        <h4>1. Before You Buy</h4>
                        <ul className="check-list">
                            <li><strong>Chat Approval Mandatory:</strong> Take confirmation before ordering (even for size/variant changes).</li>
                            <li><strong>Amazon Account Requirement:</strong> Minimum ₹1500 shopping history in the last 365 days.</li>
                            <li><strong>One-Time Rule:</strong> One product once per account — no repeats, no variants.</li>
                            <li><strong>Coins / Coupons:</strong> Strictly not allowed.</li>
                            <li><strong>Charges:</strong> Only standard delivery charges are refundable.</li>
                            <li><strong>Immediate Update:</strong> Share Order ID, Deal Type, Refund Amount & Review Name in chat after placing order.</li>
                        </ul>
                    </div>

                    <div className="guideline-block">
                        <h4>2. Screenshot Requirements</h4>
                        <ul className="check-list">
                            <li><strong>No Early Form:</strong> Minimum 3 days gap after delivery before filling refund form.</li>
                            <li><strong>High Resolution Only:</strong> Blurry or unclear screenshots will be rejected.</li>
                            <li><strong>Product Page Only:</strong> Review screenshot must be taken from the product page with product name visible.</li>
                            <li><strong>Highlight Review:</strong> Your review must be clearly marked.</li>
                            <li><strong>Device Rules:</strong> Mobile (Full screen, no cropping). Laptop (Print Screen only, 100% screen visible).</li>
                        </ul>
                    </div>

                    <div className="guideline-block">
                        <h4>3. Mandatory Verification Video (If Asked)</h4>
                        <p>Video must show the following sequence without cuts:</p>
                        <p className="sequence-text">Today’s Date ➝ Platform Order Summary ➝ Order Details (Order ID) ➝ “Delivered” Status ➝ Return Window Closed</p>
                    </div>

                    <div className="guideline-block">
                        <h4>4. Deadlines & Forms</h4>
                        <ul className="check-list">
                            <li><strong>Submission Timeline:</strong> Rating/Order/Review Submit deals (15 days). Review-only deals (20 days).</li>
                            <li><strong>Accuracy:</strong> Double-check all refund and Bank/UPI details. Errors are your responsibility.</li>
                            <li><strong>Late Penalty:</strong> Late submissions may face penalties. Maximum 10-day extension only.</li>
                            <li><strong>Timeline Count:</strong> Refund timeline starts only after correct details are submitted.</li>
                        </ul>
                    </div>

                    <div className="guideline-block">
                        <h4>5. Payments</h4>
                        <ul className="check-list">
                            <li><strong>Standard Timeline:</strong> 25–30 working days (excluding weekends & holidays).</li>
                            <li><strong>High-Value Orders (₹600+):</strong> May take 60+ days due to brand confirmation.</li>
                            <li><strong>UPI Transfers:</strong> ₹10 convenience fee if bank details are not provided.</li>
                        </ul>
                    </div>
                </section>

                <section className="tnc-section">
                    <h3><i className="ri-error-warning-line"></i> Platform Risk Clause</h3>
                    <div className="highlight-blue" style={{ background: '#fff1f2', borderColor: '#fecdd3' }}>
                        <p style={{ color: '#881337', marginBottom: '1rem' }}>We are not responsible for any platform-side issues, including but not limited to:</p>
                        <ul className="tnc-list" style={{ color: '#881337' }}>
                            <li>Order cancellations</li>
                            <li>Account suspensions / shadow bans</li>
                            <li>Delayed approvals</li>
                            <li>Review deletion, suppression, or non-visibility (Amazon / Flipkart / or any marketplace)</li>
                        </ul>
                        <p style={{ color: '#881337', marginTop: '1rem', fontWeight: 'bold' }}>If a review is not live at the time of verification, refund will be cancelled.</p>
                    </div>
                </section>

                <section className="tnc-section">
                    <h3><i className="ri-timer-flash-line"></i> Payment Timeline Disclaimer</h3>
                    <ul className="tnc-list">
                        <li>Payment timelines are fixed and non-negotiable.</li>
                        <li>Any pressure, repeated follow-ups, threats, or harassment before timeline completion may lead to deal cancellation.</li>
                        <li>If payment is delayed from the brand side, you will be informed. Brand non-payment involves <strong>NO</strong> responsibility on our side.</li>
                    </ul>
                </section>

                <section className="tnc-section">
                    <h3><i className="ri-prohibited-line"></i> One-Strike Policy</h3>
                    <p>Any violation of terms (even accidental) may lead to <strong>immediate removal</strong> from all future deals, without warning.</p>
                </section>

                <section className="tnc-section">
                    <h3><i className="ri-user-settings-line"></i> Account Authenticity Rule</h3>
                    <ul className="tnc-list">
                        <li>Only genuine, personal-use accounts are allowed.</li>
                        <li>Shared, rented, purchased, or deal-only accounts will result in <strong>instant rejection</strong>.</li>
                    </ul>
                </section>

                <section className="tnc-section">
                    <h3><i className="ri-earth-line"></i> Force Majeure / Exceptional Delay</h3>
                    <p>Payment timelines may extend due to brand delays, audits, platform verification, banking issues, technical errors, or public holidays.</p>
                </section>

                {!isEmbedded && (
                    <section className="tnc-section" style={{ textAlign: 'center', marginTop: '4rem', padding: '2rem', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                        <h3 style={{ justifyContent: 'center', border: 'none', padding: 0, marginBottom: '1rem' }}><i className="ri-checkbox-circle-fill" style={{ color: 'var(--success-green)' }}></i> Final Acceptance</h3>
                        <p style={{ fontSize: '1.1rem', fontWeight: '500' }}>By proceeding with any order, you confirm that you have read, understood, and agreed to all the above Terms & Conditions.</p>
                        <p style={{ color: 'var(--error-red)', fontWeight: 'bold' }}>No exceptions will be made under any circumstances.</p>
                    </section>
                )}
            </div>
        </div>
    );
};

export default TermsAndConditions;
